import React, {useContext} from "react";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import EnqueryList from "./List";

const ListComponent = ({component, path, parentPath, index}) => {
    const {setListData} = useContext(ScreenDesignerContextNew);
    const {properties, styles: sourceStyles, events} = component;
    const styles = sourceStyles && sourceStyles.length ? sourceStyles[0] : {};
    return (
        <div
            style={{
                width: '100%',
                // padding: styles.padding,
                height: '100%',
                position: 'relative',
            }}
        >
            <EnqueryList properties={properties || {}}
                         list={component}
                         styles={styles}
                         events={events}
                         setListData={setListData}
                         path={path}
                         parentPath={parentPath}
                         index={index}
            />
        </div>
    )
};

export default ListComponent;